import { buildProps, definePropType } from '@bigin/utils'
import type Card from './card.vue'
import type { ExtractPropTypes, StyleValue } from 'vue'

export const cardProps = buildProps({
  header: {
    type: String,
    default: '',
  },
  footer: {
    type: String,
    default: '',
  },
  headerClass: {
    type: String,
    default: '',
  },
  footerClass: {
    type: String,
    default: '',
  },
  bodyClass: {
    type: String,
    default: '',
  },
  bodyStyle: {
    type: definePropType<StyleValue>([String, Object, Array]),
    default: '',
  },
  shadow: {
    type: String,
    values: ['hover', 'never', 'lv1', 'lv2', 'lv3'],
    default: 'lv1',
  },
  bordered: Boolean,
} as const)
export type CardProps = ExtractPropTypes<typeof cardProps>
export type CardInstance = InstanceType<typeof Card>
